<template>
  <div class="main-box">
    <div class="hot-box">
      <div class="hot-title">
        <span>热门平台</span>
      </div>

      <div class="hot-list">
        <el-link
          :underline="false"
          v-for="(item, index) of hotList"
          :key="index"
          :href="'/enterprise/#/Inside?name=' + item.name"
          target="_blank"
        >
          <div class="hot-plat">
            <div class="hot-logo">
              <img :src="item.a104" />
            </div>

            <div class="hot-con">
              <span class="hot">{{ item.name }}</span>
              <p>{{ item.a103 }}</p>
            </div>
          </div>
        </el-link>
      </div>
    </div>

    <ul class="main">
      <li class="main-l">
        <div class="platform">
          <div class="platform-title">
            <span id="list2">买买生鲜</span>
            <el-link
              :underline="false"
              :href="'/enterprise/#/list?field=%E6%95%B0%E5%AD%97%E9%9B%B6%E5%94%AE&category=生鲜电商'"
              target="_blank"
              >更多>></el-link
            >
          </div>
          <div class="platform-list">
            <el-link
              :underline="false"
              v-for="(j, index) of list2"
              :key="index"
              :href="'/enterprise/#/Inside?name=' + j.name"
              target="_blank"
            >
              <div class="plat-box">
                <div class="plat-logo">
                  <img :src="j.a104" />
                </div>

                <div class="plat-con">
                  <span>{{ j.name }}</span>
                  <p>{{ j.a103 }}</p>
                </div>
              </div>
            </el-link>
          </div>
        </div>

        <div class="platform">
          <div class="platform-title">
            <span id="list4">直播购物</span>
            <el-link
              :underline="false"
              :href="'/enterprise/#/list?field=%E6%95%B0%E5%AD%97%E9%9B%B6%E5%94%AE&category=直播电商'"
              target="_blank"
              >更多>></el-link
            >
          </div>
          <div class="platform-list">
            <el-link
              :underline="false"
              v-for="(j, index) of list4"
              :key="index"
              :href="'/enterprise/#/Inside?name=' + j.name"
              target="_blank"
            >
              <div class="plat-box">
                <div class="plat-logo">
                  <img :src="j.a104" />
                </div>

                <div class="plat-con">
                  <span>{{ j.name }}</span>
                  <p>{{ j.a103 }}</p>
                </div>
              </div>
            </el-link>
          </div>
        </div>

        <div class="platform">
          <div class="platform-title">
            <span id="list3">一起团购</span>
            <el-link
              :underline="false"
              :href="'/enterprise/#/list?field=%E6%95%B0%E5%AD%97%E9%9B%B6%E5%94%AE&category=社区团购'"
              target="_blank"
              >更多>></el-link
            >
          </div>
          <div class="platform-list">
            <el-link
              :underline="false"
              v-for="(j, index) of list3"
              :key="index"
              :href="'/enterprise/#/Inside?name=' + j.name"
              target="_blank"
            >
              <div class="plat-box">
                <div class="plat-logo">
                  <img :src="j.a104" />
                </div>

                <div class="plat-con">
                  <span>{{ j.name }}</span>
                  <p>{{ j.a103 }}</p>
                </div>
              </div>
            </el-link>
          </div>
        </div>

        <div class="platform">
          <div class="platform-title">
            <span id="list9">买买吃的</span>
            <el-link
              :underline="false"
              :href="'/enterprise/#/list?field=%E6%95%B0%E5%AD%97%E9%9B%B6%E5%94%AE&category=食品电商'"
              target="_blank"
              >更多>></el-link
            >
          </div>
          <div class="platform-list">
            <el-link
              :underline="false"
              v-for="(j, index) of list9"
              :key="index"
              :href="'/enterprise/#/Inside?name=' + j.name"
              target="_blank"
            >
              <div class="plat-box">
                <div class="plat-logo">
                  <img :src="j.a104" />
                </div>

                <div class="plat-con">
                  <span>{{ j.name }}</span>
                  <p>{{ j.a103 }}</p>
                </div>
              </div>
            </el-link>
          </div>
        </div>
        <div class="platform">
          <div class="platform-title">
            <span id="list10">我要变美</span>
            <el-link
              :underline="false"
              :href="'/enterprise/#/list?field=%E6%95%B0%E5%AD%97%E9%9B%B6%E5%94%AE&category=美妆电商'"
              target="_blank"
              >更多>></el-link
            >
          </div>
          <div class="platform-list">
            <el-link
              :underline="false"
              v-for="(j, index) of list10"
              :key="index"
              :href="'/enterprise/#/Inside?name=' + j.name"
              target="_blank"
            >
              <div class="plat-box">
                <div class="plat-logo">
                  <img :src="j.a104" />
                </div>

                <div class="plat-con">
                  <span>{{ j.name }}</span>
                  <p>{{ j.a103 }}</p>
                </div>
              </div>
            </el-link>
          </div>
        </div>
        <div class="platform">
          <div class="platform-title">
            <span id="list12">买买衣服</span>
            <el-link
              :underline="false"
              :href="'/enterprise/#/list?field=%E6%95%B0%E5%AD%97%E9%9B%B6%E5%94%AE&category=服装电商'"
              target="_blank"
              >更多>></el-link
            >
          </div>
          <div class="platform-list">
            <el-link
              :underline="false"
              v-for="(j, index) of list12"
              :key="index"
              :href="'/enterprise/#/Inside?name=' + j.name"
              target="_blank"
            >
              <div class="plat-box">
                <div class="plat-logo">
                  <img :src="j.a104" />
                </div>

                <div class="plat-con">
                  <span>{{ j.name }}</span>
                  <p>{{ j.a103 }}</p>
                </div>
              </div>
            </el-link>
          </div>
        </div>

        <div class="platform">
          <div class="platform-title">
            <span id="list7">交换闲置</span>
            <el-link
              :underline="false"
              :href="'/enterprise/#/list?field=%E6%95%B0%E5%AD%97%E9%9B%B6%E5%94%AE&category=二手电商'"
              target="_blank"
              >更多>></el-link
            >
          </div>
          <div class="platform-list">
            <el-link
              :underline="false"
              v-for="(j, index) of list7"
              :key="index"
              :href="'/enterprise/#/Inside?name=' + j.name"
              target="_blank"
            >
              <div class="plat-box">
                <div class="plat-logo">
                  <img :src="j.a104" />
                </div>

                <div class="plat-con">
                  <span>{{ j.name }}</span>
                  <p>{{ j.a103 }}</p>
                </div>
              </div>
            </el-link>
          </div>
        </div>
        <div class="platform">
          <div class="platform-title">
            <span id="list8">宝妈必看 </span>
            <el-link
              :underline="false"
              :href="'/enterprise/#/list?field=%E6%95%B0%E5%AD%97%E9%9B%B6%E5%94%AE&category=母婴电商'"
              target="_blank"
              >更多>></el-link
            >
          </div>
          <div class="platform-list">
            <el-link
              :underline="false"
              v-for="(j, index) of list8"
              :key="index"
              :href="'/enterprise/#/Inside?name=' + j.name"
              target="_blank"
            >
              <div class="plat-box">
                <div class="plat-logo">
                  <img :src="j.a104" />
                </div>

                <div class="plat-con">
                  <span>{{ j.name }}</span>
                  <p>{{ j.a103 }}</p>
                </div>
              </div>
            </el-link>
          </div>
        </div>
        <div class="platform">
          <div class="platform-title">
            <span id="list15">宠物专享</span>
            <el-link
              :underline="false"
              :href="'/enterprise/#/list?field=%E6%95%B0%E5%AD%97%E9%9B%B6%E5%94%AE&category=宠物电商'"
              target="_blank"
              >更多>></el-link
            >
          </div>
          <div class="platform-list">
            <el-link
              :underline="false"
              v-for="(j, index) of list15"
              :key="index"
              :href="'/enterprise/#/Inside?name=' + j.name"
              target="_blank"
            >
              <div class="plat-box">
                <div class="plat-logo">
                  <img :src="j.a104" />
                </div>

                <div class="plat-con">
                  <span>{{ j.name }}</span>
                  <p>{{ j.a103 }}</p>
                </div>
              </div>
            </el-link>
          </div>
        </div>

        <div class="platform">
          <div class="platform-title">
            <span id="list14">买点鲜花</span>
            <el-link
              :underline="false"
              :href="'/enterprise/#/list?field=%E6%95%B0%E5%AD%97%E9%9B%B6%E5%94%AE&category=鲜花电商'"
              target="_blank"
              >更多>></el-link
            >
          </div>
          <div class="platform-list">
            <el-link
              :underline="false"
              v-for="(j, index) of list14"
              :key="index"
              :href="'/enterprise/#/Inside?name=' + j.name"
              target="_blank"
            >
              <div class="plat-box">
                <div class="plat-logo">
                  <img :src="j.a104" />
                </div>

                <div class="plat-con">
                  <span>{{ j.name }}</span>
                  <p>{{ j.a103 }}</p>
                </div>
              </div>
            </el-link>
          </div>
        </div>
        <div class="platform">
          <div class="platform-title">
            <span id="list11">来点小酒</span>
            <el-link
              :underline="false"
              :href="'/enterprise/#/list?field=%E6%95%B0%E5%AD%97%E9%9B%B6%E5%94%AE&category=酒水电商'"
              target="_blank"
              >更多>></el-link
            >
          </div>
          <div class="platform-list">
            <el-link
              :underline="false"
              v-for="(j, index) of list11"
              :key="index"
              :href="'/enterprise/#/Inside?name=' + j.name"
              target="_blank"
            >
              <div class="plat-box">
                <div class="plat-logo">
                  <img :src="j.a104" />
                </div>

                <div class="plat-con">
                  <span>{{ j.name }}</span>
                  <p>{{ j.a103 }}</p>
                </div>
              </div>
            </el-link>
          </div>
        </div>
        <div class="platform">
          <div class="platform-title">
            <span id="list6">看看好车</span>
            <el-link
              :underline="false"
              :href="'/enterprise/#/list?field=%E6%95%B0%E5%AD%97%E9%9B%B6%E5%94%AE&category=汽车电商'"
              target="_blank"
              >更多>></el-link
            >
          </div>
          <div class="platform-list">
            <el-link
              :underline="false"
              v-for="(j, index) of list6"
              :key="index"
              :href="'/enterprise/#/Inside?name=' + j.name"
              target="_blank"
            >
              <div class="plat-box">
                <div class="plat-logo">
                  <img :src="j.a104" />
                </div>

                <div class="plat-con">
                  <span>{{ j.name }}</span>
                  <p>{{ j.a103 }}</p>
                </div>
              </div>
            </el-link>
          </div>
        </div>
        <div class="platform">
          <div class="platform-title">
            <span id="list13">看点文玩</span>
            <el-link
              :underline="false"
              :href="'/enterprise/#/list?field=%E6%95%B0%E5%AD%97%E9%9B%B6%E5%94%AE&category=文玩电商'"
              target="_blank"
              >更多>></el-link
            >
          </div>
          <div class="platform-list">
            <el-link
              :underline="false"
              v-for="(j, index) of list13"
              :key="index"
              :href="'/enterprise/#/Inside?name=' + j.name"
              target="_blank"
            >
              <div class="plat-box">
                <div class="plat-logo">
                  <img :src="j.a104" />
                </div>

                <div class="plat-con">
                  <span>{{ j.name }}</span>
                  <p>{{ j.a103 }}</p>
                </div>
              </div>
            </el-link>
          </div>
        </div>

        <div class="platform">
          <div class="platform-title">
            <span id="list5">我要开店</span>
            <el-link
              :underline="false"
              :href="'/enterprise/#/list?field=%E6%95%B0%E5%AD%97%E9%9B%B6%E5%94%AE&category=电商服务商'"
              target="_blank"
              >更多>></el-link
            >
          </div>
          <div class="platform-list">
            <el-link
              :underline="false"
              v-for="(j, index) of list5"
              :key="index"
              :href="'/enterprise/#/Inside?name=' + j.name"
              target="_blank"
            >
              <div class="plat-box">
                <div class="plat-logo">
                  <img :src="j.a104" />
                </div>

                <div class="plat-con">
                  <span>{{ j.name }}</span>
                  <p>{{ j.a103 }}</p>
                </div>
              </div>
            </el-link>
          </div>
        </div>
      </li>

      <li class="main-r">
        <div class="right-box">
          <div class="right-title">
            <h1>
              <i class="el-icon-star-on" style="color: #e6a23c"></i>口碑榜
            </h1>

            <el-link
              :underline="false"
              href="/Index/complaintData.html?main=1"
              target="_blank"
            >
              更多></el-link
            >
          </div>

          <div class="load-box" v-loading="loading3">
            <ul class="pjb">
              <li v-for="(item, index) in tableData.slice(0, 48)" :key="index">
                <a
                  :href="'/Index/complaintDataDetail.html?website=' + item.name"
                  target="_blank"
                >
                  <span>{{ item.name }}</span>
                  <span>{{ item.buy.toFixed(2) }}</span>
                </a>
              </li>

              <div class="pjb-con">
                <div class="pjb-tab pjb-title">
                  <!-- <span>平台名称</span> -->
                  <span>反馈率</span>
                  <span>时效性</span>
                  <span>满意度</span>
                  <!-- <span>综合指数</span> -->
                  <span>评级</span>
                </div>

                <div
                  class="pjb-tab"
                  v-for="(pj, index) in tableData"
                  :key="index"
                >
                  <!-- <span>{{pj.name}}</span> -->
                  <span>{{ pj.pre }}</span>
                  <span>{{ pj.feedback }}</span>
                  <span>{{ pj.score_ave }}</span>
                  <!-- <span>{{pj.buy}}</span> -->
                  <span>{{ pj.grade }}</span>
                </div>
              </div>
            </ul>
          </div>
        </div>

        <div class="right-box">
          <div class="right-title">
            <h1>
              <i class="el-icon-s-flag" style="color: #67c23a"></i
              ><el-link
                style="font-size: 20px"
                href="/education/#/complainList"
                target="_blank"
                >投诉榜</el-link
              >
            </h1>

            <el-link
              :underline="false"
              href="/Index/complain.html"
              target="_blank"
            >
              我要投诉></el-link
            >
          </div>

          <div class="load-box" v-loading="loading2">
            <div class="tsb">
              <a
                v-for="(item, index) of tsb"
                :key="index"
                :href="'/Index/complain_search.html?company=' + item.company"
                target="_blank"
              >
                <span>{{ index + 1 }}</span>
                <p>{{ item.company }}</p>
              </a>
            </div>
          </div>
        </div>

        <div class="right-box">
          <div class="right-title">
            <h1>
              <i class="el-icon-message-solid" style="color: #409eff"></i
              >热点资讯
            </h1>

            <el-link
              :underline="false"
              href="http://DR.100ec.cn/"
              target="_blank"
            >
              更多></el-link
            >
          </div>

          <div class="load-box" v-loading="loading1">
            <el-tabs type="card" @tab-click="getInformation">
              <el-tab-pane
                v-for="(item, index) in tabs"
                :key="index"
                :label="item.label"
              >
                <ul class="zx-list">
                  <li v-for="(i, index) in information" :key="index">
                    <a :href="'/detail--' + i.id + '.html'" target="_blank">
                      {{ i.title }}</a
                    >

                    <!-- <p>{{i.post_date.split(/T|Z/).join(' ').slice(0, 10)}}</p> -->
                  </li>
                </ul>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Main",
  data() {
    return {
      hotList: [
        {
          name: "京东",
          a103: "京东（JD.com）是一家综合网上购物商城，销售家电、数码通讯、电脑、家居百货、服装服饰、母婴、图书、食品等。",
          a104: "https://img.qichacha.com/Product/5d426944-f745-4f6c-a87b-fadc5cf31ace.jpg",
        },
        {
          name: "拼多多",
          a103: "拼多多公司是隶属于上海寻梦信息技术有限公司的一家商家入驻模式的第三方移动电商平台,也是以人为先的新电商开创者。在以人为先的理念下,拼多多将娱乐与分享的理念融入电商运营中:用户发起邀请,在与朋友、家人、邻居等拼单成功后,能以更低的价格买到优质商品;同时拼多多也通过拼单了解消费者,通过机器算法进行精准推荐和匹配。",
          a104: "https://qccdata.qichacha.com/GroupImage/mdd3a1611424b72f69ca1c3fd0f5001f.jpg",
        },
        {
          name: "唯品会",
          a103: "唯品会是一家名牌折扣特卖电商平台，面向中国消费者提供优质、受欢迎的品牌商品，商品囊括时装、护肤品、箱包、皮具、配饰、香水、医药等等，致力于安全诚信的交易环境和服务平台、可对比的低价位、高品质的商品、专业的唯美设计、完善的售后服务。",
          a104: "https://img.qichacha.com/Product/a7456bac-481f-456b-9831-52b4c99b4119.jpg",
        },
        {
          name: "抖音",
          a103: "抖音短视频是一款音乐创意短视频社区App，用户可以使用该软件拍出属于自己的创意视频，尝试不同的视频内容，包括个人才艺、表演、舞蹈与剧情演绎，以兴趣爱好作为交友的基准。",
          a104: "https://img.qichacha.com/Product/348b0cd4-298c-44f1-8888-7d07fc1f9286.jpg",
        },
        {
          name: "快手",
          a103: "快手是一个短视频内容分享平台,用户可以在平台上直接拍摄录制短视频并分享到账号以及社交平台上,也可以利用快手软件将照片编辑成短视频模式,分享到自己的账号和社交平台。",
          a104: "https://img.qichacha.com/Investment/logo/9167d3136c6495ed5e73160749d32625.jpg",
        },
        {
          name: "京东到家",
          a103: "上海京东到家元信信息技术有限公司是中国领先的同城速递信息服务平台和无界零售即时消费平台。依托达达的高效配送和大量优秀零售合作伙伴，京东到家为消费者提供 生鲜蔬果、日用百货、医药健康、鲜花蛋糕、个护美妆等海量商品 1 小时配送到家 的极致服务体验。",
          a104: "https://imgs-b2b.toocle.com/Public/Upload/image/20220221/1645415209121086.png",
        },
        {
          name: "苏宁易购",
          a103: "苏宁易购集团股份有限公司是中国领先的智慧零售服务商,在互联网零售时代,苏宁持续推进智慧零售、场景互联战略,全品类拓展,全渠道在线,全客群融合,并通过开放供应云、用户云、物流云、金融云、营销云,实现从线上到线下,从城市到县镇,从购物中心到社区全覆盖,为消费者提供无处不在的1小时场景生活圈解决方案,全方位覆盖消费者的生活所需。",
          a104: "https://img.qichacha.com/Product/890550b6-0be5-48fc-9edf-0ecbb06b046d.jpg",
        },
        {
          name: "途虎养车",
          a103: "途虎养车是专业的'汽车养护电商平台'，主营轮胎、机油、汽车保养、汽车美容、车品等。全国万家门店，为客户提供'线上预约+线下安装'的养车方式。",
          a104: "https://image.qcc.com/logo/f943d96ae73da46473ad33654464bbf8.jpg?x-oss-process=style/logo_200",
        },
        {
          name: "网易严选",
          a103: "网易严选是网易原创生活类电商App，秉承严谨态度和 '平价优品' 的理念，致力于挤掉'虚高'品牌价格, 提供优质产品。",
          a104: "https://img.qichacha.com/Product/4fca63d4-8288-446d-a80c-9e565fa88e89.jpg",
        },
        {
          name: "小米",
          a103: "小米公司正式成立于2010年4月，是一家以手机、智能硬件和 IoT 平台为核心的互联网公司。创业仅7年时间，小米的年收入就突破了千亿元人民币。截止2018年，小米的业务遍及全球80多个国家和地区。小米的使命是，始终坚持做'感动人心、价格厚道'的好产品，让全球每个人都能享受科技带来的美好生活。",
          a104: "https://image.qcc.com/logo/9cce0780ab7644008b73bc2120479d31.jpg?x-oss-process=style/logo_200",
        },
      ],
      list1: [
        {
          name: "京东",
          a103: "京东（JD.com）是一家综合网上购物商城，销售家电、数码通讯、电脑、家居百货、服装服饰、母婴、图书、食品等。",
          a104: "https://img.qichacha.com/Product/5d426944-f745-4f6c-a87b-fadc5cf31ace.jpg",
        },
        {
          name: "拼多多",
          a103: "拼多多公司是隶属于上海寻梦信息技术有限公司的一家商家入驻模式的第三方移动电商平台,也是以人为先的新电商开创者。在以人为先的理念下,拼多多将娱乐与分享的理念融入电商运营中:用户发起邀请,在与朋友、家人、邻居等拼单成功后,能以更低的价格买到优质商品;同时拼多多也通过拼单了解消费者,通过机器算法进行精准推荐和匹配。",
          a104: "https://qccdata.qichacha.com/GroupImage/mdd3a1611424b72f69ca1c3fd0f5001f.jpg",
        },
        {
          name: "淘宝",
          a103: "淘宝网是亚太地区较大的网络零售、商圈，由阿里巴巴集团在2003年5月创立。",
          a104: "https://img.qichacha.com/Product/a2c06b6c-ce0c-410f-90e0-94f419d8f5b6.jpg",
        },
        {
          name: "天猫",
          a103: "天猫是一个B2C综合性电子商务网站。其整合数千家品牌商、生产商，为商家和消费者之间提供一站式解决方案。提供100%品质保证的商品，7天无理由退货的售后服务，以及购物积分返现等优质服务。",
          a104: "https://img.qichacha.com/Product/e0cfcbf0-1301-44ae-b850-1bff73225599.jpg",
        },
        {
          name: "苏宁易购",
          a103: "苏宁易购集团股份有限公司是中国领先的智慧零售服务商,在互联网零售时代,苏宁持续推进智慧零售、场景互联战略,全品类拓展,全渠道在线,全客群融合,并通过开放供应云、用户云、物流云、金融云、营销云,实现从线上到线下,从城市到县镇,从购物中心到社区全覆盖,为消费者提供无处不在的1小时场景生活圈解决方案,全方位覆盖消费者的生活所需。",
          a104: "https://img.qichacha.com/Product/890550b6-0be5-48fc-9edf-0ecbb06b046d.jpg",
        },
        {
          name: "唯品会",
          a103: "唯品会是一家名牌折扣特卖电商平台，面向中国消费者提供优质、受欢迎的品牌商品，商品囊括时装、护肤品、箱包、皮具、配饰、香水、医药等等，致力于安全诚信的交易环境和服务平台、可对比的低价位、高品质的商品、专业的唯美设计、完善的售后服务。",
          a104: "https://img.qichacha.com/Product/a7456bac-481f-456b-9831-52b4c99b4119.jpg",
        },
      ],
      list2: [
        {
          name: "京东到家",
          a103: "上海京东到家元信信息技术有限公司是中国领先的同城速递信息服务平台和无界零售即时消费平台。依托达达的高效配送和大量优秀零售合作伙伴，京东到家为消费者提供 生鲜蔬果、日用百货、医药健康、鲜花蛋糕、个护美妆等海量商品 1 小时配送到家 的极致服务体验。",
          a104: "https://imgs-b2b.toocle.com/Public/Upload/image/20220221/1645415209121086.png",
        },
        {
          name: "盒马鲜生",
          a103: "上海盒马网络科技有限公司是阿里巴巴集团旗下，以数据和技术驱动的新零售平台。盒马希望为消费者打造社区化的一站式新零售体验中心，用科技和人情味带给人们“鲜美生活”。",
          a104: "http://imgs-b2b.toocle.com/Public/Upload/image/20220221/1645426742570031.png",
        },
        {
          name: "本来生活",
          a103: "本来生活网是一个专注于食品、水果、蔬菜的电商网站，从优质食品供应基地、供应商中精挑细选，剔除中间环节，提供冷链配送、食材食品直送到家服务。致力于通过保障食品安全、提供冷链宅配、基地直送来改善中国食品安全现状，成为中国优质食品提供者。",
          a104: "http://imgs-b2b.toocle.com/Public/Upload/image/20220329/1648532007481142.png",
        },
        {
          name: "叮咚买菜",
          a103: "叮咚买菜是一家生鲜电商，从用户需求出发，从下而上发展，通过大数据预测单量，以降低滞销损耗率；采用智能调度和骑行路径优化，来提高末端配送效率、降低配送成本；采用从“城批采购+社区前置仓+29分钟配送”，避开“源头、冷链、冷库”的套路，来降低供应链成本问题。",
          a104: "https://img.qichacha.com/Product/0b470a38-80a6-4d1c-96d9-29a780cac82d.jpg",
        },
        {
          name: "朴朴超市",
          a103: "朴朴超市是一家生鲜快送服务提供商，涵盖果蔬、肉禽蛋奶、海鲜水产、粮油调味等品类，用户在朴朴商城选购商品后，根据定位配送地址，向附近骑手派单并进行配送；用户可通过APP端及微信端获取服务。",
          a104: "https://image.qcc.com/product/e9ba6f4b-054e-4382-af89-eb02d2775c60.jpg?x-oss-process=style/logo_200",
        },
        {
          name: "多点",
          a103: "北京多点新鲜电子商务有限公司成立于2015年4月，是生活电商领域的新锐公司，以O2O模式实现一小时送达的全品类生活电商平台，立志成为中国最大的全品类的生活电商平台。 Dmall+大型商超的模式是基于互联网+实业的新型的O2O商业模式，建立以重服务、轻仓储的分布式电商，让传统的商超迅速无缝的切入到新型的零售商业4.0模式，既帮助线下超市在这场互联网浪潮中的逆袭，而且让传统的商超将“+互联网”模式轻松",
          a104: "http://imgs-b2b.toocle.com/Public/Upload/image/20220221/1645425940489374.png",
        },
      ],
      list3: [
        {
          name: "淘鲜达",
          a103: "选购新鲜，1小时达！ 打开手机淘宝搜“淘鲜达”，好吃的都在这里！",
          a104: "https://image.qcc.com/product/57fac9ae-2f6d-43eb-8b2d-b88a972d1f96.jpg?x-oss-process=style/logo_200",
        },
        {
          name: "美团优选",
          a103: "美团优选是美团旗下的社区电商业务，采取“预购+自提”的模式，进入社区电商赛道，进一步探索社区生鲜零售业态，满足差异化消费需求，推动生鲜零售线上线下加速融合。",
          a104: "https://p0.meituan.net/mallimages/617418f2fbf3984f5c223dd7932424b015748.png",
        },
        {
          name: "兴盛优选",
          a103: "兴盛优选是一个社区电商品牌，主要定位解决家庭消费者的日常需求， 包括蔬菜水果，肉禽水产，日用百货等全品类精选商品，依托社区实体便利店，通过线上预订，门店自提的方式，所有商品今日下单，次日到店，并且消费者享受无忧售后。",
          a104: "https://image.qcc.com/product/b034633d-ed97-48cd-84eb-2810ff605011.jpg?x-oss-process=style/logo_200",
        },
        {
          name: "海豚购",
          a103: "海豚购面向2亿城市年轻人的便利需求，提供30分钟达的送货上门服务，覆盖品牌、服务、供应链、履约等各个环节。",
          a104: "https://image.qcc.com/auto/e8c1761adc4c4665c2e56d80e1913bd7.jpg?x-oss-process=style/logo_200",
        },
        {
          name: "闪电购",
          a103: "闪电购是一个提供极速购物及送货的移动社区电商平台，主要提供基于 LBS 定位一公里范围内的水果生鲜、饮料乳品、休闲零食的一小时送货到家服务。致力于解决都市年轻人吃喝急用的即时性消费需求，并提供送货上门服务.",
          a104: "https://img.qichacha.com/Product/e96af6a1-0e95-4b40-98ea-4e77d93ae600.jpg",
        },
        {
          name: "菜娘子",
          a103: "菜娘子是一家社区生鲜配送服务商，通过手机商城下单、社区冷柜自提的便捷式生鲜服务，凭借高品质的食材精选、高效的全程冷链服务获得社区消费者的广泛好评。",
          a104: "https://img.qichacha.com/Product/228faa86-3fcb-4e96-a3fe-19e05d2db458.jpg",
        },
      ],
      list4: [
        {
          name: "抖音",
          a103: "抖音短视频是一款音乐创意短视频社区App，用户可以使用该软件拍出属于自己的创意视频，尝试不同的视频内容，包括个人才艺、表演、舞蹈与剧情演绎，以兴趣爱好作为交友的基准。",
          a104: "https://img.qichacha.com/Product/348b0cd4-298c-44f1-8888-7d07fc1f9286.jpg",
        },
        {
          name: "快手",
          a103: "快手是一个短视频内容分享平台,用户可以在平台上直接拍摄录制短视频并分享到账号以及社交平台上,也可以利用快手软件将照片编辑成短视频模式,分享到自己的账号和社交平台。",
          a104: "https://img.qichacha.com/Investment/logo/9167d3136c6495ed5e73160749d32625.jpg",
        },
        {
          name: "点淘",
          a103: "淘宝网是一个综合性电商平台，涵盖男女服饰、母婴玩具、美妆护肤、珠宝首饰、运动户外以及家具电子等品类产品，为用户提供团购、分销、拍卖等多种电子商务模式，以及交易聊天、查看淘宝市场搜索热点、成交走势、定位消费人群等服务；旗下拥有闲置用品电商闲鱼、综合性导购返利电商一淘网。",
          a104: "https://image.qcc.com/logo/fa3d9de6fd3ccf354b5ae34c38eb7587.jpg?x-oss-process=style/logo_200",
        },
        {
          name: "谦寻文化",
          a103: "谦寻成立于2017年2月21日，公司目前旗下30多位主播，包括淘宝第一主播薇娅viya，以及TOP主播小侨Jofay、大英子LOVE、雪欧尼Tiffany、楚菲楚然twins、安安anan等",
          a104: "http://www.qxwhmcn.com/static/images/logo.png",
        },
        {
          name: "交个朋友",
          a103: "交个朋友是一家网红直播带货平台，主要以具有创新型的数码科技产品、优秀文创产品以及兼具设计和实用性的家居杂货为主。",
          a104: "https://image.qcc.com/product/e2d33a40-bb4c-414a-abe6-bcdaba697659.jpg",
        },
        {
          name: "辛选",
          a103: "广州辛选网络信息科技有限公司成立于2020-04-17，法定代表人为计梦瑶，注册资本为1500万元人民币，统一社会信用代码为91440101MA5D7E2B7X，企业地址位于广州市白云区黄石街道黄园路25号301B(自主申报)，所属行业为软件和信息技术服务业，经营范围包含：食品添加剂销售;卫生用品和一次性使用医疗用品销售;个人互联网直播服务（需备案）;组织文化艺术交流活动;文艺创作;非居住房地产租",
          a104: "https://image.qcc.com/auto/f50728a00fc0459fab91f97d367885d4.jpg?x-oss-process=style/logo_200",
        },
      ],
      list5: [
        {
          name: "微盟",
          a103: "微盟是针对微信公众账号提供营销推广服务的第三方平台，主要基于微信公众号为广大企业提供开发、运营、培训、推广等一体化营销推广服务，范围包括实现线上线下的互通服务、社会化客户关系管理、移动电商、轻应用等综合类业务服务。",
          a104: "https://img.qichacha.com/Product/92752e5c-fb3f-4a7a-abca-047682956e05.jpg",
        },
        {
          name: "微店",
          a103: "微店，手机开店商业模式的开创者，行业内的遥遥领先者，同时也是去中心化网络的积极探索者。",
          a104: "https://img.qichacha.com/Product/c5d89456-c3f5-49e3-a8ba-50f987ecb0e7.jpg",
        },
        {
          name: "有赞",
          a103: "有赞是一家移动零售解决方案提供商，基于云服务模式向商户提供强大的微商城系统和完整的移动零售解决方案，并致力于通过粉丝营销、交易创新、消保体系为广大商户、消费者搭建移动购物平台。",
          a104: "https://img.qichacha.com/Product/c87743b7-c1c8-4c1d-812d-d1084fbe08ab.jpg",
        },
      ],
      list6: [
        {
          name: "团车网",
          a103: "团车网是一个汽车及汽车用品团购网站，用户可以参加汽车装饰、汽车用品、 二手车、汽车保险、维修保养、学车租车等团购。",
          a104: "https://image.qcc.com/product/983455e4-22c4-4c3b-90c8-9a7e1783a7a2.jpg",
        },
        {
          name: "天天拍车",
          a103: "天天拍车是国内领先的二手车竞拍平台，现有核心业务是二手车线上竞拍，帮助个人车主高价快速卖车。同时，天天拍车还提供上门检测、免费估价、包办手续等一站式二手车交易服务。",
          a104: "https://img.qichacha.com/Product/c30db4e2-3e7c-455f-8a97-8d8fe4273509.jpg",
        },
        {
          name: "毛豆新车",
          a103: "毛豆新车，成立于2017年9月，是以线上数据和技术驱动、线下毛豆新车店深度服务相融合的一站式汽车新零售服务平台。 毛豆新车致力于满足中国消费者日益增长的汽车消费与使用需求，为消费者提供低门槛，灵活",
          a104: "https://dss0.bdstatic.com/-0U0bnSm1A5BphGlnYG/tam-ogel/e56e22042b796062da1b050f54a2e677_121_121.jpg",
        },
        {
          name: "易车",
          a103: "易车生活是一家汽车服务企业，主要业务涵盖上门洗车、养车、修车、汽车美容等多个领域，提供线上平台、智能管理系统(SaaS)、车友互助社交平台等服务，拥有综合客户服务中心和社区4S门店网络。",
          a104: "https://qccdata.qichacha.com/GroupImage/m7f8bcfa8245020e6671db29a45bfc05.jpg",
        },
        {
          name: "人人车",
          a103: "人人车是一家二手车交易服务平台，主打个人二手车、无差价交易服务。 人人车贴是私家车车身广告媒体，广告主直连车主的Uber模式。人人车库是一家库存车交易平台。网站定位B2B模式。",
          a104: "https://qccdata.qichacha.com/GroupImage/m8564ad95c8ecfbf72abbc5623f1db3b.jpg",
        },
        {
          name: "卖好车",
          a103: "卖好车是一家汽车流通服务平台。致力于通过“卖好车”线上平台、“好车物联”、“好车金融”等服务来帮助经销商一站式解决车源、钱、流转的问题，通过信息流、资金流、物流效率全面提升的方式，帮助全国汽车经销商",
          a104: "https://qccdata.qichacha.com/GroupImage/m7cfe617918af9c8855ab22a57540597.jpg",
        },
      ],
      list7: [
        {
          name: "闲鱼",
          a103: "闲鱼是一个闲置物品交易社区，会员只要使用淘宝或支付宝账户登录，无需经过复杂的开店流程，即可达成包括一键转卖个人淘宝账号中“已买到宝贝”、自主手机拍照上传二手闲置物品、以及在线交易等诸多功能。",
          a104: "https://img.qichacha.com/Product/af1a6b2b-170e-4156-83a2-58ecfc6434d7.jpg",
        },
        {
          name: "爱回收",
          a103: "爱回收是一个电子产品竞价回收平台，采用回收商竞价模式，并与京东、1号店、沃尔玛等品牌合作，为用户提供上门回收服务和一站式手机升级置换服务。通过旗下信用租机服务平台“享换机”，为用户提供分期、租赁等用机服务，用户通过芝麻信用评估后，即可免押金租手机，租约期满后，用户可以自主选择换新机续租、不换机续租或者买断，同时设有不同租期，灵活的租赁方式可以满足不同人群的各种需求。",
          a104: "http://pic.imobile.com.cn/images/source/2017/3/47/473218_b06ba.jpg",
        },
        {
          name: "转转",
          a103: "转转是一个国内二手交易领域领先的平台，同时转转在垂直领域不断深耕细作。针对二手手机交易，转转设立了“转转优品”自营业务，同时为C2C交易提供平台验机与验机质保等服务，以解决二手3C的交易信任问题。",
          a104: "https://img.qichacha.com/Product/56f0169a-3809-47ee-8c4f-97d8ffaf8e95.jpg",
        },
        {
          name: "拍机堂",
          a103: "爱回收旗下二手3C交易平台",
          a104: "https://sr.aihuishou.com/b2b/bms/index-logo2x.png",
        },
        {
          name: "找靓机",
          a103: "深圳市万事富科技有限公司旗下品牌找靓机，是国内知名二手3C电商品牌，是明星贾静雯在互联网领域的首个投资项目，截至2019年12月，平台已累计服务6700万用户，积累了21万+用户真实好评，靠着爆炸性的用户口碑，以20%的月环比增长率迅速成为专注二手手机行业的独角兽。2018年1月，找靓机获得A+轮融资7000万，受到青山资本、东方富海、梅花天使、前海母基金、宏石资本、贾静雯等投资机构的追捧和力荐。",
          a104: "https://www.zhaoliangji.com/image/logo.png",
        },
        {
          name: "孔夫子旧书网",
          a103: "孔夫子旧书网是一家专业的旧书交易平台，是传统旧书行业结合互联网而搭建的C2C平台，是C2C的精准细分市场，目前以古旧书为最大特色。截至2015年7月，孔夫子旧书网网上书店数量超过10000家",
          a104: "https://qccdata.qichacha.com/GroupImage/m9c391f8675eaca4fcb4aa8afdc6867c.jpg",
        },
      ],
      list8: [
        {
          name: "美囤妈妈",
          a103: "美囤妈妈是全球最大母婴网站宝宝树旗下的电商平台，也是中国最专业、最懂妈妈和育儿的垂直母婴电商平台。秉持宝宝树一贯的专业育儿理念，运用最先进的大数据甄选技术，美囤致力于为消费者提供愉悦的在线购物体验，致力于为各阶段的妈妈精挑细选最好、最适合的商品，做中国妈妈专属的私人买手。",
          a104: "https://image.qcc.com/logo/f282c23f80425962e7f8b56cad5ba0f1.jpg?x-oss-process=style/logo_200",
        },
        {
          name: "孩子王",
          a103: "孩子王是一家数据驱动，基于用户关系经营的创新型新家庭全渠道服务商，是中国母婴童商品零售与增值服务的领导品牌，立足于为准妈妈及0-14岁儿童提供一站式成长服务，致力于优化中国家庭的儿童生活方式，成为中国新家庭的首选服务商，服务超千万中国家庭。",
          a104: "https://qccdata.qichacha.com/GroupImage/m7f8bd74a3a4f8955bb9770318d5595c.jpg",
        },
        {
          name: "蜜芽",
          a103: "蜜芽宝贝是一家进口母婴品牌商品限时折扣特卖网站，每天在网站推荐热门的进口母婴品牌，以远低于市场价的折扣力度，在72小时内限量出售。",
          a104: "https://img.qichacha.com/Product/cbddce41-d74a-4ae4-8c67-e793f199fdbe.jpg",
        },
        {
          name: "妈妈网",
          a103: "妈妈网是一家母婴垂直门户平台，拥有资讯、社交、工具、电商等四大商业板块，旗下拥有母婴垂直门户妈妈网、女性社区妈妈网APP、广州妈妈网等32个城市妈妈网垂直社区、工具类应用孕育管家、“小树熊”母婴特卖平台等产品。",
          a104: "https://qccdata.qichacha.com/GroupImage/m7e51af3f2725438393afc3b06d0722a.jpg",
        },
        {
          name: "妈妈帮",
          a103: "妈妈帮是以知识和交流为核心，通过个性化服务、专业工具等建立核心优势的专业、可信赖的移动母婴生活服务平台；是大多数中国母婴人群获取知识、解疑答惑、社群交流，乃至健康问题求助、购物推荐、同龄伙伴聚会等需求的集中解决平台。",
          a104: "https://img.qichacha.com/Product/db10b76c-8c5b-4267-943f-fa7c0a90b9f6.jpg",
        },
        {
          name: "年糕妈妈",
          a103: "年糕妈妈是一个母婴亲子公众平台，为数十万妈妈们提供靠谱、易懂、接地气的科学育儿资讯，并开有微店。致力于为所有新手爸妈甄选婴幼儿产品，打造成国内领先的婴幼儿产品购物、社群综合平台，多业务模式并线发展。",
          a104: "https://qccdata.qichacha.com/GroupImage/m1896e41b81557fa462e036bc07325de.jpg",
        },
      ],
      list9: [
        {
          name: "中粮我买网",
          a103: "中粮我买网投资有限公司成立于2012-04-05，法定代表人为陈朗，注册资本为48000万美元，统一社会信用代码为911100005906873829。企业地址位于北京市朝阳区朝阳门南大街8号18F-10室，所属行业为商务服务业。",
          a104: "https://imgs-b2b.toocle.com/Public/Upload/image/20220214/1644818561756156.png",
        },
        {
          name: "51零食",
          a103: "51零食是一家办公室自助零食货架服务商，采用货架、小冰箱、货架冰箱一体机（上层是货架，底层是冰箱）三种设备，为企业提供零食、水果生鲜产品，并与同城的蛋糕店合作，提供扫码预订蛋糕的服务。",
          a104: "https://img.qichacha.com/Product/e69d4754-0225-401d-9c34-f246327699b9.jpg",
        },
        {
          name: "良品铺子",
          a103: "湖北良品铺子食品有限公司是一家研发和推广零食的公司，致力于为客户提供好吃的健康的零食。",
          a104: "https://img.qichacha.com/Product/38303cea-2315-4a81-9d7c-b62cdb3d09cd.jpg",
        },
        {
          name: "好食期",
          a103: "好食期是一个品牌食品特卖平台，为用户提供国内外品牌的近万种食品，2-6折特卖价格，所有商品均显示保质期，同时旗下拥有线下商家砍价平台“爱抢购”，涵盖餐饮、休闲娱乐及食品等领域。",
          a104: "https://img.qichacha.com/Product/4937a8bc-013f-4d12-8189-1a17b53325fb.jpg",
        },
        {
          name: "百草味",
          a103: "百草味是一个坚果零食品牌，产品线涵盖了坚果炒货、蜜饯、糕点、肉干、花茶等五大系列约300多个单品，采用连锁加盟、线下直营、线上通过第三方电商平台、以及自建平台等模式进行产品销售。",
          a104: "https://img.qichacha.com/Product/2afca003-e727-4573-a95a-154aeaaa056a.jpg",
        },
        {
          name: "三只松鼠",
          a103: "三只松鼠，是一家专注于坚果、干果、茶叶等森林食品的研发、分装及B2C品牌销售的现代化新型企业，以互联网技术为依托，利用B2C平台实行线上销售。致力于开创一个以食品产品的快速、新鲜的新型食品零售模式。",
          a104: "https://img.qichacha.com/Product/a2114ffe-78cd-41ef-b049-090eab55f160.jpg",
        },
      ],
      list10: [
        {
          name: "丝芙兰",
          a103: "中国官方购物网站,100%正品!汇聚兰蔻、雅诗兰黛、纪梵希等近百个国际品牌,超5千款美妆护肤产品,支持货到付款。",
          a104: "https://imgs-b2b.toocle.com/Public/Upload/image/20220420/1650442398620408.png",
        },
        {
          name: "种子宣言",
          a103: "种子宣言是一个O2O电商平台，专注于精华原液、面膜等美容护肤产品及化妆品的生产、销售，拥有私人仓储，支持在线支付，提供送货上门服务，隶属于亚妍（上海）化妆品有限公司。",
          a104: "https://image.qcc.com/product/15f2ef38-2458-423b-88be-f537d1d20bff.jpg?x-oss-process=style/logo_200",
        },
        {
          name: "完美日记",
          a103: "PerfectDiary完美日记是一个国产彩妆品牌，研发一系列“易上手、高品质、精设计”的时尚彩妆产品，为新一代中国女性提供快时尚彩妆产品和美丽方案。打造有国际影响力的CHINA BEAUTY ICON。",
          a104: "https://img.qichacha.com/Product/3ceb3217-93fc-4e95-9991-e89741e0f4a0.jpg",
        },
        {
          name: "尚妆网ShowJoy",
          a103: "尚妆网ShowJoy是一个化妆品电商平台，设立尚妆国际、限时特买、试用优选、品牌馆等板块，产品涵盖香水、护肤、彩妆等品类，为用户提供个性化推荐、先试后买等服务，支持45天包退换，用户可通过网站购买商品。",
          a104: "https://img.qichacha.com/Product/d8d61d89-dbf6-4401-ba0e-d8d03bc258ba.jpg",
        },
        {
          name: "MFA会员说",
          a103: "MFA会员说是一个会员制美妆电商平台，致力于打造特色包年制会员电商的平台模式，依靠自身完善的供应链优势，为大众打造“闭着眼睛买，大牌品质好用不贵”的购物体验，上线至今获得了消费市场的巨大认可，拥有广泛的成长空间。",
          a104: "https://img.qichacha.com/Product/fe7558da-0448-439d-af1b-390fc70a3824.jpg",
        },
        {
          name: "HARMAY",
          a103: "HARMAY話梅以当代风尚、审美为核心，传递关于美和美好的生活方式。涵盖国际一线彩妆护肤品、全球小众精品、以及HARMAY話梅的同名自有品牌，包括护肤、生活方式类产品。HARMAY話梅采取新零售方式，在香港、上海、北京、成都等地均设有门店，并在线上设有HARMAYCONCEPT旗舰店及HARMAY話梅创始店",
          a104: "https://img.qichacha.com/Product/619e3f6e-fced-4e4e-80ff-511c016d63c6.jpg",
        },
      ],
      list11: [
        {
          name: "中酒网",
          a103: "中酒网是一个中高档酒类商品B2C和O2O电子商务服务商，主营国产中高档白酒、红酒、进口红酒和洋酒等，隶属于中酒时代酒业（北京）有限公司。",
          a104: "https://img.qichacha.com/Product/774faa1c-7afe-424f-a924-ed813a1bbb8a.jpg",
        },
        {
          name: "酒仙网",
          a103: "酒仙网是酒类电子商务综合服务公司，专业电子商务B2C酒水连锁零售网站，借助于现代电子商务平台主力主要从事国际国内知名品牌、地方畅销品牌以及进口优秀品牌等酒类商品线上零售。",
          a104: "https://img.qichacha.com/Product/7c47b156-acb7-411c-8c39-3586be2dae8f.jpg",
        },
        {
          name: "酒美网",
          a103: "酒美网隶属于北京玖美电子商务有限公司，是专业的进口葡萄酒电子商务网站，采用进口葡萄酒直购平台模式。 酒美网定位为中国消费者提供全球精选葡萄酒产品，同时基于互联网和线下品酒沙龙俱乐部为广大红酒爱好者们提供一个开放的交流与分享的社交平台和圈子。针对VIP客户，酒美网提供一对一的私人顾问式坐席服务和私人化品酒服务，以及高端品酒沙龙。",
          a104: "https://img.qichacha.com/Product/aa3e87a9-4dc5-4d0d-a240-70d0f365c3a3.jpg",
        },
        {
          name: "1919酒类直供",
          a103: "1919酒类直供是一个酒类直供平台，通过酒类网上商城以及线下酒类连锁超市，提供白酒、国产葡萄酒、进口葡萄酒、洋酒、黄酒、啤酒、果酒、酒柜、酒具等各种产品。",
          a104: "https://img.qichacha.com/Product/951e4b79-7019-4f4f-bb7a-edfa93a20661.jpg",
        },
        {
          name: "红酒盒子",
          a103: "红酒盒子 成立于 2014 年，主要垂直于葡萄酒领域，消费者可以在我们的网站或微信公众平台上上直接购买葡萄酒及相关产品，或者订阅齐绍仁每月为会员们精挑细选的葡萄酒。 同时，我们还在制作两档网络视频节目，《齐人其酒》和《齐谈》各位小伙伴可以上网搜索一下，更进一步的了解我们哦……",
          a104: "https://img.qichacha.com/Product/7a7a5a9c-796e-43c7-a299-4c12903dc28c.jpg",
        },
        {
          name: "三两酒",
          a103: "三两酒是「川酒泰斗」陈茂椿第三代传人，从国外留学归来的陈剑峰，采用了陈氏古老、传统的配方，加上数百年的匠心改良，又历时三年时间，共同调制的一款——和五粮同宗同质同料，一脉相承的极简小酒。",
          a104: "https://img.qichacha.com/Product/9cb464846b6b46e8a3fa2da2e9c7fb58.jpg",
        },
      ],
      list12: [
        {
          name: "壹仓优品",
          a103: "壹仓优品以经营国内著名服装品牌、运动品牌、商务休闲品牌、鞋皮具品牌、童装品牌为一体，较早涉足“多品牌经营、跨行业发展”的全新零售业态。以新乡总部为中心辐射全国，在国内三、四线城市和城镇乡村布局线下连锁加盟品牌集合折扣店、品牌集合店，以同一经营标识“壹仓优品”进行集中式销售，并以实体店铺带动周边消费者成为线上客户和品牌推广者，致力打造“店商+电商+消费生态圈”的新零售模式。",
          a104: "https://image.qcc.com/product/c98d0ba6-5c06-4ab0-9bef-88257b78db58.jpg?x-oss-process=style/logo_200",
        },
        {
          name: "韩都衣舍",
          a103: "韩都衣舍是一个服饰电商平台，主要面向20-35岁互联网消费人群提供线下传统品牌和国外品牌商等，涵盖女装、男装、童装、中老年服装、相关配饰及服务等业务，产品包括韩风系、欧美系、东方系等主流风格。",
          a104: "https://img.qichacha.com/Product/756d695f-5b11-4b4b-a800-1ef8f4cde179.jpg",
        },
        {
          name: "太平鸟",
          a103: "太平鸟是一家以零售为导向的多品牌时尚服饰企业，以“让每个人尽享时尚的乐趣”为使命，秉持“活出我的闪耀”的品牌主张，致力于为消费者提供中等价位的优质时尚服饰。,简介： 太平鸟集团有限公司，致力于企业创新、时尚魅力的太平鸟，是一家以服饰品牌的创意、设计和营销为产业核心，同时发展汽车商城、供应链管理、商业投资为一体的多元化企业集团。",
          a104: "https://img.qichacha.com/Product/b48d0d7e-34f6-4f28-89eb-7392124d0abb.jpg",
        },
        {
          name: "好衣库",
          a103: "好衣库是一家集日、韩风格,时尚女装批发代销与零售为一体的销售平台。作为平台方一边连接品牌供应商，一边连接代购，在这样的一个双边市场中，通过控品、控货、控价，面对海量的高性价比货源和线上线下的一线品牌供应商。",
          a104: "https://img.qichacha.com/Product/c77114bc-9056-45ec-8e2a-88bf9e787234.jpg",
        },
        {
          name: "奕尚网络",
          a103: "奕尚网是一个综合B2C网站，专注于中高档品牌服饰网上销售, 致力于为消费者提供一流网上购物体验。 上海奕尚网络信息有限公司旗下网站。,简介： 临沂沂尚网络科技服务有限公司是一家致力于电子商务服务、电子商务运营、电子商务培训为一体的综合性电子商务公司。,简介： 潍坊伊尚网络科技有限公司是一家网络信息咨询服务商",
          a104: "https://img.qichacha.com/Product/6635958a-ad7a-4688-854f-7a9a101b5df6.jpg",
        },
        {
          name: "Bananain蕉内",
          a103: "蕉内BananaIn是一家新锐内衣品牌，产品主要涵盖内裤、袜子、文胸、保暖衣、家居服、轻户外等品类。针对日常通勤、户外、居家等场景和需求，蕉内最初于2016年11月独创Tagless无感标签技术。",
          a104: "https://img.qichacha.com/Product/ee090a0a-3eff-4578-aff0-426e0c82b3b7.jpg",
        },
      ],
      list13: [
        {
          name: "微拍堂",
          a103: "微拍堂是一个社交类C2C拍卖平台，通过移动互联网技术，致力于为用户提供交流分享、商品购买的平台。用户可在平台上发布自己的拍品，并通过微信借口实时通知买卖双方交易情况，且用户可设置保证金，防止恶意交易，9兼容微信、银行卡等多种支付方式。",
          a104: "https://img.qichacha.com/Product/a951af34-efab-426b-a118-d4539ed03ba6.jpg",
        },
        {
          name: "玩物得志",
          a103: "玩物得志是一个国风文玩电商平台，平台主要为用户提供国风文玩物品，包括陶瓷紫砂、刺绣、书画篆刻、玉翠珠宝等，同时，平台还具有限时秒杀等优惠活动。",
          a104: "https://img.qichacha.com/Product/07977d55-eb02-4702-a330-e7e4ba38c33d.jpg",
        },
        {
          name: "对庄翡翠",
          a103: "对庄翡翠，成立于2015年，是行业领军的翡翠渠道品牌，致力于整合各大上游翡翠供应商，从源头市场严控货源，为消费者甄选高性价比精品翡翠。对庄翡翠坚持“用户第一”理念，行业首创第三方鉴定担保交易、7天无理由退换货、1000万真品保障金等多重保障，为每件商品提供鉴定服务与钱货担保。对庄翡翠自上线以来已累计800万用户40万真实评价。好翡翠，上对庄。",
          a104: "https://www.duizhuang.com/img/tab_icon_logo.png",
        },
        {
          name: "唯一艺术",
          a103: "TheOne.art是一个数字艺术电商平台，致力于让更多艺术创作者可以获得数字艺术发行收益，让中国文化和中国创作可以得到快速的传播和价值认同。",
          a104: "https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/images/pic-home/logo.svg",
        },
        {
          name: "文玩鉴定",
          a103: "文玩鉴定是一款手机拍照鉴宝应用，手机随时拍照上传即可鉴定，既有专家在线鉴定30分钟内便知真假，也可向专家咨询藏品价值，让您随时对接行内专家，在这里您可以随时随地与行内玩家直接交流或求购藏品。文玩鉴定是您的古玩淘宝助手。隶属于邢台子安信息科技有限责任公司。",
          a104: "http://file.market.xiaomi.com/thumbnail/PNG/l114/AppStore/0a825522fcd174edb495f933eeef4821da2413382",
        },
        {
          name: "艺狐在线",
          a103: "北京艺狐在线网络科技有限公司成立于2015年，项目总投资1000万元。 艺狐在线是基于互联网和移动端而开发的综合性在线拍卖平台，提供“线上实时拍卖”和“线上线下同步实时拍卖”两大核心技术支撑，给拍卖企业和广大藏家提供了一种革命性的拍卖新途径，以改变中国艺术品拍卖行业20余年千篇一律的陈旧方式。",
          a104: "https://image.qcc.com/logo/3f715abd071bc2ddf5839e8e7d47ecd7.jpg?x-oss-process=style/logo_200",
        },
      ],
      list14: [
        {
          name: "花礼网",
          a103: "中国鲜花礼品网是一家主打鲜花、礼品速递服务的电商品牌，隶属于深圳市百易信息技术有限公司。",
          a104: "https://imgs-b2b.toocle.com/Public/Upload/image/20220210/1644477677126283.png",
        },
        {
          name: "中国鲜花网",
          a103: "中国鲜花网投资创办于2005年，目前在全国已经设立超过6000家直营及配送商；网点多、范围广的同行业优势曾多次被国内多个权威主流媒体（CNTV、中华网、中国日报等）相继报道，是当今中国领先的鲜花礼品速递服务商。自成立以来一直保持高速成长，Alexa世界排名居同类网站前列，现已成长为中国具影响力的鲜花网站。",
          a104: "https://img.qichacha.com/Product/cbdabc9e-2195-45b4-aa66-f3db87493d09.jpg",
        },
        {
          name: "速递花",
          a103: "速递花是南昌全元科技旗下一款手机智能订花应用，并且还支持送花服务，在异地也能够享受。",
          a104: "https://img.qichacha.com/Product/e13b0e42-3944-4b80-b242-a493ac7f4c31.jpg",
        },
        {
          name: "花意生活",
          a103: "花意生活成都电子商务有限公司，历经10多年的辛勤耕耘，是国内大型鲜花商城品牌之一。10多年来公司专注于鲜花速递行业，本着“快捷、诚信、便利”的宗旨，专业提供鲜花配送服务。",
          a104: "http://9844216.s21i.faiusr.com/4/ABUIABAEGAAgiZ222gUoiZDd9AIwmAI4Mg.png",
        },
        {
          name: "花集网",
          a103: "花集网是一个鲜花电子商务平台，致力于提供花卉网络咨询服务，整合花商资源，供平台上的花店和零售客户参考，开展异地或同城远距离送花业务的需要，提供一站式上门到家服务。",
          a104: "https://img.qichacha.com/Product/75de49ad-9dec-4c10-bcfd-09973ea447b5.jpg",
        },
        {
          name: "爱丽丝花艺生活馆",
          a103: "爱丽丝花艺生活馆是一个礼品鲜花配送平台，用户可依据自己对鲜花造型、用途的需求选择花艺师或鲜花成品，产品分为生日系列、节日系列、生活系列等，同时是该平台依托第三方物流团队，为用户提供配送服务。",
          a104: "https://co-image.qichacha.com/CompanyImage/ce810c7c13c0546ca4e3aa2b099b2cec.jpg?x-oss-process=style/qcc_cmp",
        },
      ],
      list15: [
        {
          name: "波奇宠物",
          a103: "波奇宠物致力于为养宠爱宠人士提供线上线下的一站式服务。旗下拥有宠物用品商城、宠物服务、宠物百科、波奇论坛、波奇无线等诸多平台，全方位打造海量养宠资讯、精致爱宠服务和琳琅满目的商品，全面关爱宠物生活。",
          a104: "https://img.qichacha.com/Product/161c280d-90e4-4445-a3b4-b359551af085.jpg",
        },
        {
          name: "宠物之家",
          a103: "宠物之家隶属于北京宠家科技有限公司，是一个宠物社交平台，提供宠物观看、养宠资讯、购买宠物等服务。实时上传更新有关宠物的护养方法、有趣故事、精彩论坛推荐。",
          a104: "https://img.qichacha.com/Product/f4f286f6-c46b-4081-9e85-3de8e73239b4.jpg",
        },
        {
          name: "小贴士Tips",
          a103: "小贴士tips是一个宠物医保服务平台，基于宠物医疗健康数据的分析，面向养宠大众提供宠物健康管理计划方案，产品包括小淘气健康保障计划、大壮壮健康保障计划、老顽童健康保障计划。",
          a104: "https://img.qichacha.com/Product/60d7091c-4d1d-4d05-b115-2da55d5d2801.jpg",
        },
        {
          name: "遛遛",
          a103: "遛遛是一个宠物社交平台，专注于移动宠物服务与宠物社交，针对宠物爱好者开发的移动应用。通过地理位置，帮助发现身边萌宠和宠物主人；更精准迅速地解决宠物主人实际的配种、领养与寄养等需求；创建有爱平台，满足宠物主人之间养宠分享和互助交流等社交愿望。",
          a104: "https://image.qcc.com/product/4359a11c-d4f7-4ed6-9120-4e9d620dfe4c.jpg",
        },
        {
          name: "in宠",
          a103: "in宠是一家从宠物领养切入的宠物一站式服务平台，成立于2016年8月底，in宠是一个专门为宠物主提供图片社交、管家提醒的平台。app内时常组织各种有趣的线上线下主题活动，为宠物主提供养护以及健康事项提醒，每天可以在上面分享各种宠物美图，同时也可以在上面结交宠友，欣赏别人家的可爱宠物。",
          a104: "https://image.qcc.com/product/ee4ad136-4c9f-4379-8fc3-bcc756593d48.jpg",
        },
        {
          name: "超能小黑",
          a103: "超能小黑是一个狗粮品牌，为宠物提供鲜肉鲜蔬、零添加剂、保质期15天的宠物鲜粮，保障狗狗摄入足量的营养物质，有益于生长发育。用户按月订购，一次性付费，根据狗狗食量每周配送一次。",
          a104: "https://img.qichacha.com/Product/65599ec8-6d07-4581-a367-309f70d1117e.jpg",
        },
      ],
      loading1: false,
      loading2: false,
      loading3: false,
      activeName: "1",
      tabs: [
        {
          value: "1",
          label: "数字零售",
        },
        {
          value: "直播电商",
          label: "直播电商",
        },
        {
          value: "生鲜电商",
          label: "生鲜电商",
        },
        {
          value: "社区团购",
          label: "社区团购",
        },
        {
          value: "文玩电商",
          label: "文玩电商",
        },
        {
          value: "汽车电商",
          label: "汽车电商",
        },
        {
          value: "二手电商",
          label: "二手电商",
        },
        {
          value: "母婴电商",
          label: "母婴电商",
        },
        {
          value: "社交电商",
          label: "社交电商",
        },
        {
          value: "618",
          label: "618",
        },
      ],
      information: [],
      complaints: [],
      tsb: [],
      parameter2: {},
      tableData: [],
      parameter: {
        p: 1,
        pagesize: 24,
        a100: "数字零售",
        a102: "",
      },
      platform: [
        {
          title: "综合",
          id: "list1",
          list: [],
        },
        {
          title: "生鲜",
          id: "list2",
          list: [],
        },
        {
          title: "社区团购",
          id: "list3",
          list: [],
        },
        {
          title: "直播",
          id: "list4",
          list: [],
        },
        {
          title: "社交",
          id: "list5",
          list: [],
        },
        {
          title: "汽车",
          id: "list6",
          list: [],
        },
        {
          title: "二手",
          id: "list7",
          list: [],
        },
        {
          title: "母婴",
          id: "list8",
          list: [],
        },
        {
          title: "食品",
          id: "list9",
          list: [],
        },
        {
          title: "美妆",
          id: "list10",
          list: [],
        },
        {
          title: "酒水",
          id: "list11",
          list: [],
        },
        {
          title: "服装",
          id: "list12",
          list: [],
        },
        {
          title: "文玩",
          id: "list13",
          list: [],
        },
        {
          title: "鲜花",
          id: "list14",
          list: [],
        },
        {
          title: "宠物",
          id: "list15",
          list: [],
        },
      ],
    };
  },
  created() {
    this.getInformation({ label: "数字零售" });
    // this.getComplaints()
    if (new Date().getMonth >= 2) {
      this.parameter2 = {
        type: 1,
        year: new Date().getFullYear(),
      };
    } else {
      this.parameter2 = {
        type: 1,
        year: new Date().getFullYear() - 1,
        time: "whole_year",
      };
    }
    this.getTsb();
    this.getPlatform();
    this.getRating();
  },
  methods: {
    getInformation(key) {
      this.loading1 = true;
      if (key.label == "数字零售") {
        this.$axios.get("/searchjsonb.html?p=1&n=10&terms=1").then((res) => {
          this.information = res.data.list;
        });
      } else {
        this.tabs.forEach((item) => {
          if (item.label == key.label) {
            this.$axios
              .get("/searchjson.html?p=1&n=10&terms=" + item.value)
              .then((res) => {
                this.information = res.data.list;
              });
          }
        });
      }
      this.loading1 = false;
    },
    getTsb() {
      this.loading2 = true;
      this.$axios
        .get(
          "https://www.100ec.cn/315/api/index.php?_a=product&f=most_company_list&type=1&limit=&year=" +
            this.parameter2.year +
            "&time=" +
            this.parameter2.time
        )
        .then((res) => {
          this.tsb = res.data.list.slice(0, 10);
          this.loading2 = false;
        });
    },
    getRating() {
      this.loading3 = true;
      this.$axios({
        method: "post",
        url: "https://www.100ec.cn/315/api/index.php?_a=data",
        data: this.parameter2,
      }).then((res) => {
        for (var i of res.data.list) {
          this.tableData.push({
            name: i.company,
            pre: i.pre,
            feedback: i.feedback,
            score_ave: i.score_ave,
            buy: i.buy * 100,
            grade: i.if_green == 0 && i.buy == 0 ? "不予评级" : i.grade,
          });
        }
        this.loading3 = false;
      });
    },
    getPlatform() {
      for (var i of this.platform) {
        this.parameter.a102 = i.title;
        this.$axios({
          method: "post",
          url: "/Index/new_data_json?dataid=13",
          data: this.parameter,
        }).then((res) => {
          this.platform.forEach((item) => {
            if (item.title == res.data.list[0].a102) {
              item.list = res.data.list;
            }
          });
        });
      }
    },
  },
};
</script>

<style scoped>
.main-box {
  max-width: 1200px;
  margin: 0 auto 40px auto;
}

/* 平台推荐 */
.hot-box {
  background: #fff;
  margin: -38px 0 30px;
  zoom: 1;
}

.hot-title {
  text-align: center;
  border-bottom: 1px solid #f1f4f9;
  padding: 10px 30px;
}

.hot-title span {
  font-size: 24px;
  color: #333;
  line-height: 50px;
  letter-spacing: 5px;
}

.hot-list {
  display: flex;
  flex-wrap: wrap;
}

.hot-list .el-link {
  /* flex: 0 0 18%; */
  display: flex;
  justify-content: left;
  padding: 2%;
  transition: all 0.5s ease-in-out;
}

.hot-list .el-link:hover {
  background: #dd0000;
  box-shadow: 0 0 5px #dd0000, 0 0 25px #dd0000, 0 0 50px #dd0000,
    0 0 200px #dd0000;
  -webkit-box-reflect: below 1px linear-gradient(transparent, #0005);
}

.hot-plat {
  display: flex;
}

.hot-logo {
  width: 50px;
  height: 50px;
  border-radius: 0.1rem;
  overflow: hidden;
}

.hot-logo img {
  width: 100%;
  height: 100%;
}

.hot-con {
  flex: 1;
  padding-left: 10px;
}

.hot-con span {
  font-size: 18px;
  font-weight: bold;
  color: #dd0000;
  transition: all 0.5s ease-in-out;
}

.hot-list .el-link:hover span {
  color: #fff;
}

.hot-con p {
  font-size: 12px;
  color: #888;
  width: 110px;
  height: 3em;
  line-height: 1.5em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-top: 5px;
  transition: all 0.5s ease-in-out;
}

.hot-list .el-link:hover p {
  color: #ccc;
}

.hot {
  position: relative;
  font-size: 18px;
  color: #5c5be3;
}

.hot::after {
  content: "";
  width: 20px;
  height: 20px;
  background: url("/Public/home/images/huo.png");
  background-size: cover;
  position: absolute;
  top: calc(50% - 12px);
  right: -20px;
}

/*  */
.main {
  display: flex;
  justify-content: space-between;
}

.main-l {
  flex: 1;
  margin-right: 20px;
  /* height:400px;
  overflow-y:scroll; */
}

.main-r {
  width: 300px;
}

.platform {
  background: #fff;
  border-radius: 10px;
}

.platform-title {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f1f4f9;
  padding: 10px 30px;
}

.platform-title span {
  font-size: 24px;
  color: #dd0000;
  line-height: 50px;
  position: relative;
  padding-left: 18px;
}

.platform-title span::before {
  content: "";
  width: 4px;
  height: 18px;
  background-color: #dd0000;
  position: absolute;
  top: calc(50% - 12px);
  left: 0px;
}

.platform-list {
  display: flex;
  flex-wrap: wrap;
  padding: 0 15px;
  margin: 10px 0 30px;
}

.platform-list .el-link {
  flex: 0 0 23%;
  justify-content: left;
  padding: 1%;
}

.platform-list img {
  width: 100%;
}

.plat-box {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  transition: all 0.5s ease-in-out;
}

.plat-box:hover {
  background: #f2f8fd;
}

.plat-logo {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
}

.plat-logo img {
  width: 100%;
  height: 100%;
}

.plat-con {
  width: 190px;
  padding-left: 10px;
}

.plat-con span {
  font-weight: bold;
  color: #333;
  transition: all 0.5s ease-in-out;
}

.plat-box:hover span {
  color: #dd0000;
}

.plat-con p {
  font-size: 12px;
  color: #888;
  height: 3em;
  line-height: 1.5em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-top: 5px;
}

/* 右边布局 */
.right-box {
  background: #fff;
  border-radius: 10px;
  margin-bottom: 20px;
}

.load-box {
  min-height: 200px;
  padding: 10px 20px;
}

.right-title {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f1f4f9;
  padding: 10px 30px;
}

.right-title h1 {
  font-size: 20px;
  line-height: 50px;
}

.right-title i {
  font-size: 20px;
  padding-right: 5px;
}

/* 资讯 */
.zx-list li {
  display: flex;
  font-size: 14px;
  color: #555;
  line-height: 40px;
  position: relative;
  padding-left: 2%;
}

.zx-list li::before {
  content: "";
  width: 6px;
  height: 6px;
  background: #dd0000;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: calc(50% - 3px);
}

.zx-list li:hover a {
  color: #dd0000;
}

.zx-list li a {
  font-size: 14px;
  color: #555;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding-left: 10px;
  transition: all 0.5s ease-in-out;
}

.zx-list li p {
  color: #888;
}

/* 投诉榜 */
.tsb a {
  display: flex;
  line-height: 40px;
  margin: 10px 0;
  transition: all 0.5s ease-in-out;
}

.tsb span {
  width: 50px;
  font-family: Impact;
  font-size: 2rem;
  color: #000;
  opacity: 0.25;
  margin: 0 20px;
  transition: all 0.5s ease-in-out;
}

.tsb p {
  width: 180px;
  font-size: 20px;
  color: #333;
  letter-spacing: 2px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  transition: all 0.5s ease-in-out;
}

.tsb a:nth-child(1) p,
.tsb a:nth-child(1) span {
  color: crimson;
  opacity: 1;
}
.tsb a:nth-child(2) p,
.tsb a:nth-child(2) span {
  color: darkorange;
  opacity: 1;
}
.tsb a:nth-child(3) p,
.tsb a:nth-child(3) span {
  color: darksalmon;
  opacity: 1;
}

.tsb a:hover span {
  color: #dd0000;
  opacity: 1;
  margin-right: 30px;
}

.tsb a:hover p {
  color: #dd0000;
}

/* 评级榜 */
.pjb {
  position: relative;
}

.pjb li {
  line-height: 50px;
  background: #fafafa;
  border-radius: 2rem;
  padding: 0 20px;
  margin-bottom: 10px;
  transition: all 0.5s ease-in-out;
}

.pjb li:nth-child(1) {
  background: #dc143c !important;
}

.pjb li:nth-child(2) {
  background: #ff8c00 !important;
}

.pjb li:nth-child(3) {
  background: #e9967a !important;
}

.pjb li:hover {
  border-radius: 0;
}

.pjb li a {
  display: flex;
  justify-content: space-between;
  color: #555;
}

.pjb li:nth-child(1) a,
.pjb li:nth-child(2) a,
.pjb li:nth-child(3) a {
  color: #fff;
}

.pjb li span {
  font-size: 20px;
}

.pjb-con {
  width: 350px;
  height: 570px;
  background: #fff;
  opacity: 0;
  position: absolute;
  top: -80px;
  right: 240px;
  z-index: -1;
  transition: all 0.5s ease-in-out;
}

.pjb:hover .pjb-con {
  opacity: 1;
  box-shadow: -5px 0 5px #eee;
  right: 260px;
  z-index: 100;
}

.pjb-tab {
  display: flex;
  justify-content: space-between;
  background: #fafafa;
  line-height: 50px;
  padding: 0 20px;
  margin-bottom: 10px;
}

.pjb-con .pjb-tab:nth-child(2) {
  background: #dc143c;
}

.pjb-con .pjb-tab:nth-child(3) {
  background: #ff8c00;
}

.pjb-con .pjb-tab:nth-child(4) {
  background: #e9967a;
}

.pjb-con .pjb-tab:nth-child(2),
.pjb-con .pjb-tab:nth-child(3),
.pjb-con .pjb-tab:nth-child(4) {
  color: #fff;
}

.pjb-title {
  padding: 10px 20px;
}

.pjb-title span {
  font-weight: bold;
}

.pjb-tab span {
  flex: 0 0 25%;
  font-size: 14px;
}
@media (max-width: 1100px) {
  .main-box {
    margin: 0 auto 0px auto;
  }
  .hot-list {
    display: flex;
    flex-wrap: wrap;
  }
  .hot-list .el-link {
    display: flex;
    justify-content: left;
    padding: 0;
    margin: 4px;
    transition: all 0.5s ease-in-out;
  }
  .hot-con span {
    font-size: 16px;
    font-weight: 700;
    color: #dd0000;
    transition: all 0.5s ease-in-out;
  }
  .main {
    width: 100%;
    display: block;
  }
  .main-l {
    width: 100%;
    flex: 1;
    margin: 0;
    /* margin-right: 20px; */
  }
  .main-r {
    /* display: none; */
    width: 100%;
  }
  .load-box {
    height: 340px;
    overflow: hidden;
    min-height: 200px;
    padding: 10px 20px;
  }
  .platform-list {
    display: flex;
    flex-wrap: wrap;
    height: 400px;
    overflow: hidden;
    padding: 0 15px;
    margin: 10px 0 20px;
  }
  .platform-list .el-link {
    flex: 0 0 23%;
    justify-content: left;
    padding: 0;
  }
  .load-box {
    height: 350px;
    overflow: hidden;
    min-height: 200px;
    padding: 10px 20px;
  }
  .plat-con p {
    width: 270px;
  }
}
</style>